export const getUcpBackendUrl = (): string =>
  (process.env.NEXT_PUBLIC_API_BASE_URL ?? '').replace(/\/$/, '');

export const ucpBackendUrl = (path: string): string => {
  const base = getUcpBackendUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (!base) return normalized;

  return `${base}${normalized}`;
};
